import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ExcelExportService } from "src/app/services/excel-export.service";
import { ReportService } from "src/app/services/report.service";
import { DEPENDENCY_FIELDS, REPORT_DEPENDENCIES } from "./report-dependencies";

@Component({
  selector: "app-secure-reports",
  templateUrl: "./reports.component.html",
  styleUrls: ["./reports.component.scss"],
})
export class ReportsComponent implements OnInit {
  
  isLoading = false;
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  lotteryList: {[key: number]: string};
  reports: {[key: string]: string};

  constructor(
    private router: Router,
    private reportService: ReportService,
    private excelExportService: ExcelExportService
  ) {}

  ngOnInit(): void {
    this.loadData();
    this.form = new FormGroup({
      selectedReport: new FormControl("", Validators.required),
    });
  }

  loadData() {
    this.isLoading = true;
    this.reportService.initReportForm()
    .subscribe((data) => {
      this.isLoading = false;
        if(data.status === 'SUCCESS') {
          this.lotteryList = data.lotteryList;
          this.reports = data.reports;
        }
        else {
          this.reportService.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.reportService.errorToast(error?.error?.message || error?.error?.errorMessage);
        this.isLoading = false;
      }
    );
  }

  onSubmit() {
    if (this.form.valid) {
      this.isLoading = true;

      if(this.form.value.selectedReport.key.indexOf('JASPER') >= 0) {
        this.reportService.generateReport(+this.form.value.selectedReport.key.replace('JASPER', ''), {
          lotteryKey: this.form.value.lotteryKey?.key
        })
        .subscribe((data) => {
          this.isSubmitDisabled = false;
          this.isLoading = false;
          if(data.status === 'SUCCESS') {
            this.downloadFile(data.base64File, data.fileName);
          }
          else {
            this.reportService.errorToast(data.errorMessage);  
          }
        }, error => {
          this.isLoading = false;
          this.isSubmitDisabled = false;
          this.reportService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
        });
      }
      else if(this.form.value.selectedReport.key.indexOf('QUERY') >= 0) {
        this.reportService.fetchQueryExecutorReport(+this.form.value.selectedReport.key.replace('QUERY', ''))
        .subscribe((data) => {
          this.isSubmitDisabled = false;
          this.isLoading = false;
          if(data.status === 'SUCCESS') {
            this.excelExportService.exportExcel(data.title, data.columnNames, 
              data.lst, data.columnWidths, 
              data.generatedBy, data.generatedOn);
          }
          else {
            this.reportService.errorToast(data.errorMessage);  
          }
        }, error => {
          this.isLoading = false;
          this.isSubmitDisabled = false;
          this.reportService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
        });
      }
    }
    else {
      this.isSubmitDisabled = false;
    }
  }

  addDependency(e: any) {
    Object.keys(DEPENDENCY_FIELDS).forEach(o => {
      this.form.removeControl(o);
    });
    if(e !== '') {
      REPORT_DEPENDENCIES[e.value]?.forEach(o => {
        this.form.addControl(o, new FormControl("", Validators.required));
      })
    }
  }

  downloadFile(base64:string | ArrayBuffer, fileName:string){
    const src = `${base64}`;
    const link = document.createElement("a")
    link.href = src
    link.download = fileName
    link.click()
    
    link.remove()
  }
}